import { Toast } from '@easyvaas/js-components';
import React, { useEffect, useMemo, useState } from 'react';
import { useRecoilCallback, useRecoilValue } from 'recoil';
import SmallText from 'src/components/SmallText';
import { useCheckMaterialEnough } from '../../hooks/useCheckMaterialEnough';
import { useClosePopup } from '../../hooks/useClosePopup';
import { useOpenPopup } from '../../hooks/useOpenPopup';
import { imagesV3Data, polishPieces } from '../../services';
import {
  materialItemSelector,
  typedMaterialItemSelector
} from '../../store/selector';
import { imagePopupState, resultState } from '../../store/state';
import ImageOperationPopup from '../ImageOpreationPopup';
import styles from './index.module.scss';

const renderFooter = () => (
  <p className={styles.description}>
    1.每种宝石一次打磨10个，不够10个不能打磨，打磨10个产出也是10个
    <br />
    2.打磨宝石需要使用金刚磨石，金刚磨石为道具，只在商城里出售
  </p>
);
const PolishPopup = () => {
  const close = useClosePopup();
  const open = useOpenPopup();
  const { target, visible } = useRecoilValue(imagePopupState('polish'));
  const current = useRecoilValue(materialItemSelector(target));
  const next = useRecoilValue(
    materialItemSelector(current?.specialExtend?.polishToolId || 0)
  );
  const check = useCheckMaterialEnough();
  const material = useRecoilValue(typedMaterialItemSelector(6));
  const [number, setNumber] = useState(1);
  const max = useMemo(() => {
    if (!current || !material) return 0;
    const count1 = Math.floor(current.number / 10);
    const count2 = material.number;
    return Math.max(1, Math.min(count1, count2));
  }, [current, material]);

  const onClick = useRecoilCallback(({ set }) => async () => {
    if (!material || !current) return;
    if (
      !current.specialExtend ||
      !current.specialExtend.piecesType ||
      !current.specialExtend.polishToolId
    ) {
      Toast('该材料不可打磨');
      return;
    }
    if (!check(material, number)) return;

    Toast.loading('打磨中...');
    await polishPieces({
      piecesType: current.specialExtend.piecesType,
      number: 10 * number
    });
    await imagesV3Data.refresh({});
    Toast.hide();
    set(resultState, {
      number: number * 10,
      toolId: material.toolId
    });
    close('polish');
    open('result', current.specialExtend.polishToolId);
  });
  useEffect(() => {
    if (visible) {
      return () => {
        setNumber(1);
      };
    }
  }, [material, visible]);
  if (!current || !next || !material) return null;
  return (
    <ImageOperationPopup
      type="polish"
      title="宝石打磨"
      position="bottom"
      className={styles.container}
      confirmText="打磨"
      onClick={onClick}
      renderFooter={renderFooter}
      popupClassName={styles.popup}
    >
      <div className={styles.item}>
        <img src={current.logo} alt="" />
        <div className={styles.title}>{current.title}</div>
        <div className={styles.own}>
          拥有<span>{current.number}</span>
        </div>
        <SmallText className={styles.count} fontSize={18} inline>
          {number * 10}
        </SmallText>
      </div>
      <div className={styles.number}>
        <button
          className={styles.plus}
          onClick={() => setNumber(v => Math.min(max, v + 1))}
        />
        <button
          className={styles.minus}
          onClick={() => setNumber(v => Math.max(1, v - 1))}
        />
        <SmallText fontSize={20} className={styles.text} inline>
          转换数量
        </SmallText>
      </div>
      <div className={styles.item}>
        <img src={next.logo} alt="" />
        <div className={styles.title}>{next.title}</div>
        <div className={styles.own}>
          拥有<span>{next.number}</span>
        </div>
        <SmallText className={styles.count} fontSize={18} inline>
          {number * 10}
        </SmallText>
      </div>
      <div className={styles.material}>
        <SmallText fontSize={22} inline>
          消耗：
        </SmallText>
        <div
          className={styles.logo}
          style={{ backgroundImage: `url(${material.logo})` }}
        />
        <div className={styles.info}>
          <SmallText fontSize={22} inline>
            {material.title}*{number}
          </SmallText>
          <SmallText fontSize={22} inline>
            拥有<span className={styles.accent}>{material.number}</span>
          </SmallText>
        </div>
      </div>
      <div className={styles.tips}>
        您将使用{number}
        {material.title}将 {current.title}*{10 * number}打磨成{next.title}*
        {10 * number}
      </div>
    </ImageOperationPopup>
  );
};

export default React.memo(PolishPopup);
